const {NAMESPACE_MAPPING} = require('@wix/document-services-json-schemas/build/namespaceMapping')

const DESIGN_PARTS = ['item', 'sub-item']

const DEFAULT_VALUES = {
    color: 'rgba(var(--color_15),1)',
    'text-transform': 'none',
    'text-highlight': 'rgba(0, 0, 0, 0)',
    'letter-spacing': 'normal',
    'line-height': 'normal'
}

const stylePropsToMigrate = Object.keys(DEFAULT_VALUES)

const convertRevertedStyleProps = styleProps => {
    DESIGN_PARTS.forEach(type => {
        stylePropsToMigrate.forEach(prop => {
            const fullPropName = `${type}-${prop}`
            if (styleProps[fullPropName] === 'revert') {
                styleProps[fullPropName] = DEFAULT_VALUES[prop]
            }
        })
    })

    return styleProps
}

const COMPONENT_STYLE_TYPE = 'ComponentStyle'

const migrateStructuredMegaMenuSubmenuDesign = (pageManager, component) => {
    const {components: megaMenuContainerItems} = component

    megaMenuContainerItems.forEach(megaMenuContainerItem => {
        const {components: megaMenuContainerItemComponents} = megaMenuContainerItem

        if (megaMenuContainerItemComponents.length === 0) return

        const [submenuComponent] = megaMenuContainerItemComponents

        const styleItem = pageManager.data.getItem(NAMESPACE_MAPPING.style, submenuComponent.styleId)

        if (styleItem.type === COMPONENT_STYLE_TYPE) {
            const componentStyleProps = styleItem.style.properties
            convertRevertedStyleProps(componentStyleProps)
        } else {
            styleItem.values.forEach(styleKey => {
                const cleanedStyleKey = styleKey.replace('#', '')
                const currentBreakpoint = pageManager.data.getItem(NAMESPACE_MAPPING.style, cleanedStyleKey)
                if (currentBreakpoint.type === 'VariantRelation') {
                    const variantKey = currentBreakpoint.to.replace('#', '')
                    const variantStyleProps = pageManager.data.getItem(NAMESPACE_MAPPING.style, variantKey).style
                        .properties

                    convertRevertedStyleProps(variantStyleProps)
                }

                if (currentBreakpoint.type === COMPONENT_STYLE_TYPE) {
                    const componentStyleProps = currentBreakpoint?.style?.properties
                    convertRevertedStyleProps(componentStyleProps)
                }
            })
        }
    })
}

module.exports = {
    migrateStructuredMegaMenuSubmenuDesign
}
